import React from 'react';
import {
  Box,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Heading,
} from '@chakra-ui/react';

const Faq = () => {
  const faqItems = [
    {
      heading: 'Is Albumshot for photographers?',
      description:
        'Yes, Albumshot is for photographers. Photographers can create premium online albums and easily share with clients. Photographers can create multiple folders inside an album.',
    },
    {
      heading: 'Are the albums private or public?',
      description:
        'We have both options. Inside the album settings, photographers have an option to turn on/off password. Albums or photos can be easily shared privately with a password.',
    },
    {
      heading: 'Are Albumshot client gallery mobile friendly?',
      description:
        'Yes, Albumshot client galleries are mobile friendly. It can be viewed in any mobile.',
    },
    {
      heading: 'How do I upgrade or downgrade my plan?',
      description:
        'If you upgrade or choose a more expensive plan in the middle of a billing interval, the new plan will take effect immediately and start a new order term based on the selected billing interval. You will also be charged immediately for the new plan. The amount due will be reduced by prorated amount based on the time remaining in your previous order term for the lower priced plan. While you can upgrade your plan at any time, downgrades will take effect at the end of your billing interval.',
    },
    {
      heading: 'Have more questions?',
      description:
        'We’re here to help you. You can message directly on our chat option.',
    },
  ];

  return (
    <Box
      bg='dark.95'
      textAlign='center'
      py='160px'
      px={['32px', '32px', '32px', '0px']}
    >
      <Box textAlign='left' maxWidth='780px' margin='0 auto'>
        <Heading
          as='h3'
          mb='64px'
          color='white'
          fontWeight='bold'
          fontSize='40px'
          fontFamily='bold'
        >
          Frequently Asked Questions
        </Heading>
        <Accordion defaultIndex={[0]} allowMultiple fontSize='md'>
          {faqItems.map((item, index) => (
            <AccordionItem key={index} border='none' pb='40px'>
              <AccordionButton color='white' _focus={{ boxShadow: 'none' }}>
                <Box flex='1' textAlign='left'>
                  {item.heading}
                </Box>
                <AccordionIcon />
              </AccordionButton>
              <AccordionPanel
                color='white'
                textAlign='left'
                fontFamily='regular'
                fontWeight='regular'
              >
                {item.description}
              </AccordionPanel>
            </AccordionItem>
          ))}
        </Accordion>
      </Box>
    </Box>
  );
};
export default Faq;
